import { defineComponent, ref, reactive, computed } from "vue";
import { useRouter } from "vue-router";
import { auth } from "~/core";
import { MsgBox } from "~/components/MsgBox";
import { api } from "~/api";
import { Log, Validator, presence } from "~/extensions/utils";
import Loading from 'quasar/src/plugins/loading/Loading.js';
import { routeManager } from "src/router/RouteManager";
import { commonStore } from "~/store/CommonStore";
import { LoginModel } from "~/pages/login/Models/LoginModel";
import { useAppVersion } from "~/boot/Version";
import { GetPasswordResetUrlResult } from "~/api/data/Common/GetPasswordResetUrlResult";
import dayjs from "dayjs";
const log = Log.create("LoginPage");
const requiredErrorMessage = "入力してください。";
let constraints = {
    loginId: {
        presence: presence(false, requiredErrorMessage)
    },
    password: {
        presence: presence(false, requiredErrorMessage)
    }
};
export default defineComponent({
    name: "MTLoginPage",
    beforeRouteEnter(to, from, next) {
        if (!commonStore.initError) {
            next();
            return;
        }
        next({ name: "404" });
    },
    setup() {
        const data = reactive(new LoginModel());
        const valid = reactive(new Validator(data, constraints));
        const busy = ref(false);
        const router = useRouter();
        const copyright = process.env.copyright;
        let passwordResetResult = new GetPasswordResetUrlResult();
        const functionsUrl = ref("");
        const initView = async () => {
            passwordResetResult = await api.common.getPasswordResetUrl();
            functionsUrl.value = passwordResetResult.url;
        };
        const isMaintenanceVisible = computed(() => {
            const now = dayjs();
            const start = dayjs("2026-06-17T00:00:00");
            const end = dayjs("2026-06-23T21:00:00");
            return now >= start && now <= end;
        });
        const login = async () => {
            if (valid.error) {
                return;
            }
            try {
                Loading.show();
                busy.value = true;
                let version = useAppVersion();
                data.appJsHash = version?.appJsHash ?? "";
                data.vendorJsHash = version?.vendorJsHash ?? "";
                auth.user = await api.auth.mtLogin(data);
                await commonStore.init();
                routeManager.initRoute(router);
                if (auth.user.isPasswordReset) {
                    router.push({ name: "admin-password-change" });
                }
                else {
                    router.push({ name: "top" });
                }
            }
            catch (ex) {
                log.error("login", ex);
                if (!valid.handle(ex)) {
                    MsgBox.error(ex.data.errorMessage);
                    auth.logoutLocal();
                }
            }
            finally {
                busy.value = false;
                Loading.hide();
            }
        };
        initView();
        Loading.hide();
        return {
            data,
            valid,
            busy,
            login,
            copyright,
            passwordResetResult,
            functionsUrl,
            isMaintenanceVisible
        };
    }
});
